export default __webpack_public_path__ + "static/media/stacked_books.be78b2ab.png";